export default __webpack_public_path__ + "static/media/aj-logo.841ad0ba.png";